var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGe(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.3 0h53.4v40H.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "M23 0h8v40h-8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "M.3 16h53.4v8H.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "red",
    fillRule: "evenodd",
    d: "M12.6 31c0-1.3.3-2.5.3-2.5h-2.5s.3 1.2.4 2.6c-1.4 0-2.6-.3-2.6-.3v2.4l2.6-.3-.4 2.6H13s-.3-1.2-.3-2.6c1.4 0 2.6.3 2.6.3L15 32v-1.2l-2.5.3M43.2 7c.1-1.3.4-2.5.4-2.5H41l.3 2.6c-1.4 0-2.6-.3-2.6-.3L39 8v1.2l2.5-.3c0 1.4-.3 2.6-.3 2.6h2.5s-.3-1.2-.4-2.6c1.4 0 2.6.3 2.6.3V6.8zM12.6 7c0-1.3.3-2.5.3-2.5h-2.5s.3 1.2.4 2.6c-1.4 0-2.6-.3-2.6-.3v2.4l2.6-.3-.4 2.6H13s-.3-1.2-.3-2.6c1.4 0 2.6.3 2.6.3L15 8V6.8zm30.6 24c.1-1.3.4-2.5.4-2.5H41l.3 2.6c-1.4 0-2.6-.3-2.6-.3L39 32v1.2l2.5-.3-.3 2.6h2.5s-.3-1.2-.4-2.6c1.4 0 2.6.3 2.6.3v-2.4l-2.6.3",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.3 0h53.3v40H.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGe);
export default __webpack_public_path__ + "static/media/ge.0ed9aff470c89a85bba93c913e1cdd13.svg";
export { ForwardRef as ReactComponent };